import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const payoutsApi = createApi({
    reducerPath: 'payoutsApi',
    tagTypes: ['payouts'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getPayouts: build.query({
            query: (data) => ({
                url: api.payouts.getPayouts(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, {arg}) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({currentArg, previousArg}) => {
                return currentArg !== previousArg;
            },
        }),
        updatePayout: build.mutation({
            query: ({id, ...data}) => ({
                url: api.payouts.updatePayout(id),
                method: 'PUT',
                body: data
            }),
            async onQueryStarted(patch, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled
                    dispatch(
                        payoutsApi.util.updateQueryData('getPayouts', patch, (draft) => {
                            const index = draft?.findIndex((payout) => payout.id === patch.id);
                            if (index !== -1) {
                                draft[index] = {
                                    ...draft[index],
                                    status: 'success'
                                }
                            }
                        })
                    );
                } catch (e) {
                    console.error('Refund failed:', e)
                }
            },
        }),
    })
})

export const {useLazyGetPayoutsQuery, useUpdatePayoutMutation} = payoutsApi
